<h5 class="vg-heading-five asset-allocation-header">Asset allocation</h5>
<p *ngIf="chartData?.asOfDate; else noData" class="as-of-date vg-paragraph-two vg-gray"
    data-rpa-tag-id="assetAllocationDate">as of {{ chartData?.asOfDate | ESTPipe }}
</p>

<div *ngIf="chartData?.asOfDate != null" class="asset-allocation-container">
    <exemplar-donut-chart [chartId]="chartId" [tableId]="tableId" [chartData]="chartAndTable" [decimals]="2"
        [selectPathData]="selectPathData">
    </exemplar-donut-chart>
    <div *ngIf="!!dataSource?.filteredData?.length" id="{{tableId}}ExportDiv">
        <mat-table id="{{tableId}}" [dataSource]="dataSource" matSort matSortActive="name">
            <ng-container matColumnDef="allocationByColor">
                <mat-header-cell *matHeaderCellDef><span [innerHTML]=""></span></mat-header-cell>
                <mat-cell *matCellDef="let row; let indexId = index"><svg id="cr{{indexId}}"
                        class="circle bulletAlignTop">
                        <circle cx="10" cy="10" r="5" />
                    </svg></mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span>Asset class</span>
                </mat-header-cell>
                <mat-cell id="donutChartContentName{{indexId}}"
                    *matCellDef="let row; let indexId = index">{{row.name}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="value">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span data-rpa-tag-id="assetClass">
                        {{fundId}}</span></mat-header-cell>
                <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                    data-rpa-tag-id="assetClassPct">
                    {{row.value | percentage: 2}}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row id="{{row.id}}TR" *matRowDef="let row; columns: displayedColumns;"
                (mouseover)="selectPath(row.id, $event)"></mat-row>
        </mat-table>
    </div>
</div>

<ng-template #noData>
    <div class="col-sm-12">
        <p class="no-data rps-paragraph-one">This information is temporarily unavailable.</p>
    </div>
</ng-template>